import {EnvelopeNewIcon} from 'shells/icon';
import {CollapsibleStatBreakdown} from 'shells/metrics/collapsible-stat-breakdown/collapsible-stat-breakdown';

import type {EmailMembershipStatsFragment as MembershipStats} from 'nutshell-graphql-types';
type Props = {
    stats: MembershipStats;
    isCollapsed: boolean;
    showChevron?: boolean | null | undefined;
};

export function CollapsibleEmailStats(props: Props) {
    const excludedCount = props.stats.totalCount.value - props.stats.subscribedCount;

    return (
        <CollapsibleStatBreakdown
            isCollapsed={props.isCollapsed}
            icon={EnvelopeNewIcon}
            title='Email subscribers'
            value={props.stats.subscribedCount}
            showChevron={props.showChevron || false}
            statsBreakdown={{
                header: `Reasons ${excludedCount.toLocaleString()} out of ${props.stats.totalCount.value.toLocaleString()} were excluded`,
                details: [
                    {
                        label: 'Duplicate email',
                        value: props.stats.duplicateEmailCount,
                    },
                    {
                        label: 'Missing email',
                        value: props.stats.noEmailCount,
                    },
                    {
                        label: 'Bouncing',
                        value: props.stats.bouncedCount,
                    },
                    {
                        label: 'Unsubscribed',
                        value: props.stats.unsubscribedCount,
                    },
                ],
            }}
            shouldExcludeZeroes={true}
        />
    );
}
